import { Howl } from 'howler'
import audioTheme1 from '~/assets/audio/theme-1.mp3'
import audioTheme2 from '~/assets/audio/theme-2.mp3'
import audioTheme3 from '~/assets/audio/theme-3.mp3'
import audioTheme4 from '~/assets/audio/theme-4.mp3'

const soundTheme1 = new Howl({
  src: audioTheme1,
  html5: true,
})

const soundTheme2 = new Howl({
  src: audioTheme2,
  html5: true,
})

const soundTheme3 = new Howl({
  src: audioTheme3,
  html5: true,
})

const soundTheme4 = new Howl({
  src: audioTheme4,
  html5: true,
})

export const soundByTheme = {
  'theme 1': soundTheme1,
  'theme 2': soundTheme2,
  'theme 3': soundTheme3,
  'theme 4': soundTheme4,
}
